import ajaxServiceByApiGateway from './ajaxServiceByApiGateway';

export default {
  // 撈取mgm活動資料(專門給會員中心使用)
  getMGMInfo(params, headers) {
    return ajaxServiceByApiGateway.get('/getactmgminfov1', params, headers);
  },

  // 撈取mgm活動資料(前台頁面使用)
  getMGMUserinfo(params, headers) {
    return ajaxServiceByApiGateway.get('/getactmgmdatav1', params, headers);
  },

  // 新增MGM活動按鈕紀錄
  postMgmInvitedButton(body) {
    return ajaxServiceByApiGateway.post('/postactmgminvitedbuttonv1', body);
  },

  // MGM活動受邀頁紀錄
  postMgmInvitedPage(body) {
    return ajaxServiceByApiGateway.post('/postactmgmlogv1', body);
  },

};
